<template>
  <div class="flex flex-col items-start">
    <div class="flex items-center gap-2 mb-1 w-full">
      <span class="text-sm text-gray-400">
        {{ $t('report.herfindahl_index') }}
      </span>
      <button
        @click.stop="showInfo = true"
        class="flex items-center justify-center w-4 h-4 text-gray-400 hover:text-blue-500 transition-colors"
        :title="$t('hhi.info.title')"
      >
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" class="w-4 h-4">
          <path stroke-linecap="round" stroke-linejoin="round" d="m11.25 11.25.041-.02a.75.75 0 0 1 1.063.852l-.708 2.836a.75.75 0 0 0 1.063.853l.041-.021M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9-3.75h.008v.008H12V8.25Z" />
        </svg>
      </button>
    </div>
    <div class="flex items-center gap-2">
      <span class="text-lg font-bold">
        {{ hhiValue }}
      </span>
      <div
        :class="[
          'px-2 py-1 rounded-full text-xs font-semibold text-white',
          badgeColorClass
        ]"
      >
        {{ $t(`hhi.${categoryKey}`) }}
      </div>
    </div>
  </div>

  <BottomSheet v-model:is-open="showInfo" variant="sidebar">
    <HHIInfoSheet />
  </BottomSheet>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue'
import BottomSheet from './BottomSheet.vue'
import HHIInfoSheet from './HHIInfoSheet.vue'

interface Props {
  hhiValue: number
}

const props = defineProps<Props>()

const showInfo = ref(false)

const category = computed(() => {
  const value = props.hhiValue
  
  if (value >= 0 && value <= 1500) {
    return { key: 'excellent', color: 'bg-green-500' }
  } else if (value > 1500 && value <= 2500) {
    return { key: 'good', color: 'bg-blue-500' }
  } else if (value > 2500 && value <= 4000) {
    return { key: 'average', color: 'bg-yellow-500' }
  } else if (value > 4000 && value <= 6000) {
    return { key: 'bad', color: 'bg-red-500' }
  } else {
    return { key: 'poor', color: 'bg-red-700' }
  }
})

const categoryKey = computed(() => category.value.key)
const badgeColorClass = computed(() => category.value.color)
</script>